import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

const extractItemKey = key => {
  const arrVals = String(key)
    .split('>>')
    .pop()
    .split(':');
  const [val1, val2] = arrVals;
  const result = (val2 || val1 || '').substr(0, 50);
  return result.endsWith('-') ? result.substr(0, result.length - 1) : result;
};

/* eslint-disable no-unused-vars */
export default analyticsData => ([type, { key }]) => {
  const { actionTracking = {}, dtm = {} } =
    Object.values(analyticsData || {}).find((item = {}) =>
      key.match(new RegExp(`${(item.keywords || []).join('.*')}`, 'g'))
    ) || {};

  const dtmVal =
    !!dtm.eventAction && String(dtm.eventAsset).indexOf('${itemKey}') > -1
      ? {
          ...dtm,
          eventAsset: replaceStringWithVars({
            varsObject: { itemKey: extractItemKey(key) },
            string: dtm.eventAsset
          })
        }
      : dtm;
  if (dtmVal.eventAction) {
    sendDTMClickEvent(dtmVal);
  }
};
